import { atom } from "recoil";

export const activeStepState = atom({
    key: 'activeStep',
    default: 0
});

export const completedStepState = atom({
    key: 'completedStep',
    default: {}
})

export const activeTabReservationState = atom({
    key: 'activeTabReservation',
    default: "2"
});

export const executeReservationState = atom({
    key: 'executeReservation',
    default: false
})